module.exports = __webpack_public_path__ + "static/polco-2a087215204c7c30fb7c7eb2b66032f7.webm";